var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8 1.8V2.67111L6.64432 7.56724C7.14446 8.07274 7.425 8.75514 7.425 9.46625V15.6866L10.575 14.6253V9.46625C10.575 8.75514 10.8555 8.07274 11.3557 7.56724L16.2 2.67111V1.8H1.8ZM17.1 0C17.5971 0 18 0.402944 18 0.9V3.0411C18 3.27814 17.9065 3.50561 17.7398 3.67411L12.6352 8.83325C12.4685 9.00174 12.375 9.22921 12.375 9.46625V15.5951C12.375 15.7882 12.2517 15.9599 12.0687 16.0215L6.21867 17.9924C5.92702 18.0906 5.625 17.8737 5.625 17.5659V9.46625C5.625 9.22921 5.53149 9.00174 5.36477 8.83325L0.260228 3.67411C0.0935114 3.50561 0 3.27814 0 3.04111V0.900001C0 0.402944 0.402944 0 0.9 0H17.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.fdadcea7dd418dfb12c91d4157f73c1c.svg";
export { ForwardRef as ReactComponent };